/**
 * Progressive (blur-up) image component.
 *
 * Shows a tiny, blurred placeholder immediately, then reveals the full-resolution
 * image over it once it has finished loading. Adds the "is-loaded" class when ready.
 *
 * Degrades gracefully: the fade behavior is scoped to progressive-image:defined in CSS,
 * so if this script never runs the full image is simply shown as-is.
 */
class ProgressiveImage extends HTMLElement {
  connectedCallback() {
    this.full = this.querySelector('.progressive-image__full');

    if (!this.full) {
      this.reveal();
      return;
    }

    // Already cached / decoded (e.g. served from the browser cache on navigation).
    if (this.full.complete && this.full.naturalWidth > 0) {
      this.reveal();
      return;
    }

    this._onLoad = () => this.reveal();
    this.full.addEventListener('load', this._onLoad, { once: true });
    this.full.addEventListener('error', this._onLoad, { once: true });
  }

  disconnectedCallback() {
    if (this.full && this._onLoad) {
      this.full.removeEventListener('load', this._onLoad);
      this.full.removeEventListener('error', this._onLoad);
    }
  }

  reveal() {
    this.classList.add('is-loaded');
  }
}

if (!window.customElements.get('progressive-image')) {
  window.customElements.define('progressive-image', ProgressiveImage);
}
